import env from 'config/env';
import { useCallback } from 'react';
import { IListagemCampanha, IListagemCanal, IListagemFornecedora, IListagemOrganization, IListagemRole, IListagemStatusCampanha, IListagemUsuariosCampanha } from 'shared/types';

export interface IKeyValue {
  key: string,
  value: string
}

export interface IKeyValueNumber {
  key: number,
  value: string
}

export const isValidDate = (d?: string) => {
  if (typeof d === 'string') {

    const timestamp = Date.parse(d);
    if (isNaN(timestamp) == false) {
      return true;
    }
  }
  return false;
};

export const dateToLocalISO = (date: Date) => {

  const off = date.getTimezoneOffset();
  const absoff = Math.abs(off);
  return (new Date(date.getTime() - off * 60 * 1000).toISOString().substring(0, 23) +
    (off > 0 ? '-' : '+') +
    Math.floor(absoff / 60).toFixed(0).padStart(2, '0') + ':' +
    (absoff % 60).toString().padStart(2, '0'));
};


export const stringToLocalISO = (strDate: string) => {
  const timestamp = Date.parse(strDate);
  if (isNaN(timestamp) == false) {
    const date = new Date(strDate);
    const off = date.getTimezoneOffset();
    const absoff = Math.abs(off);
    return (new Date(date.getTime() - off * 60 * 1000).toISOString().substring(0, 23) +
      (off > 0 ? '-' : '+') +
      Math.floor(absoff / 60).toFixed(0).padStart(2, '0') + ':' +
      (absoff % 60).toString().padStart(2, '0'));
  }
  return strDate;
};



export const currentDateHour = (hora: 'atual' | 'primeira' | 'ultima') => {
  if (hora === 'primeira') {
    const dataCur = new Date();
    dataCur.setHours(0, 0, 0);
    return dataCur.toISOString();
  }
  if (hora === 'ultima') {
    const dataCur = new Date();
    dataCur.setHours(23, 59, 59);
    return dataCur.toISOString();
  }
  return new Date().toISOString();
};

export const stringToIsoDate = (date: string) => {
  if (date == null) return '';
  try {
    return new Date(date).toISOString();
  }
  catch {
    return date;
  }
};


export const stringToDate = (date: string) => {
  if (date == null) return '';
  try {
    return new Date(date).toLocaleDateString(env.language);
  }
  catch {
    return date;
  }
};

export const stringToDateTime = (date: string) => {
  if (date == null) return '';
  try {
    return new Date(date).toLocaleString(env.language).replace(',','');
  }
  catch {
    return date;
  }
};

export const stringToTime = (date: string) => {
  if (date == null) return '';
  try {
    return new Date(date).toLocaleTimeString(env.language);
  }
  catch {
    return date;
  }
};

export const listagemOrgToIKeyValue = (listOrg: IListagemOrganization[]): IKeyValue[] => {
  // eslint-disable-next-line prefer-const
  let arr: IKeyValue[] = [];
  listOrg.map(org => (
    arr.push({key: org.CodigoOrganizacao.toString(), value: org.OrganizacaoNome})
  ));
  return arr;
};

export const listagemCanalToIKeyValue = (listCanal: IListagemCanal[]): IKeyValue[] => {
  // eslint-disable-next-line prefer-const
  let arr: IKeyValue[] = [];
  listCanal.map(canal => (
    arr.push({ key: canal.IdCanal.toString(), value: canal.NomeCanal })
  ));
  // console.log(arr) ;
  return arr;
};
export const listagemFornecedoraToIKeyValue = (listFornecedora: IListagemFornecedora[]): IKeyValue[] => {
  // eslint-disable-next-line prefer-const
  let arr: IKeyValue[] = [];
  listFornecedora.map(fornecedora => (
    arr.push({ key: fornecedora.IdFornecedora.toString(), value: fornecedora.NomeFornecedora })
  ));
  return arr;
};


export const listagemRoleToIKeyValue = (listRole: IListagemRole[]): IKeyValue[] => {
  // eslint-disable-next-line prefer-const
  let arr: IKeyValue[] = [];
  listRole.map(role => (
    arr.push({ key: role.IdRole.toString(), value: role.NomeRole })
  ));
  return arr;
};

export const listagemStatusToIKeyValue = (listStatus: IListagemStatusCampanha[]): IKeyValue[] => {
  // eslint-disable-next-line prefer-const
  let arr: IKeyValue[] = [];
  listStatus.map(status => (
    arr.push({ key: status.valor, value: status.texto })
  ));
  return arr;
};

export const listagemUsersToIKeyValue = (listUsers: IListagemUsuariosCampanha[]): IKeyValue[] => {
  // eslint-disable-next-line prefer-const
  let arr: IKeyValue[] = [];
  listUsers.map(user => (
    arr.push({ key: user.IdUsuarioCampanha.toString(), value: user.UsuarioCampanhaNome })
  ));
  return arr;
};

export const listagemCampanhaToIKeyValue = (listCampanha: IListagemCampanha[]): IKeyValue[] => {
  // eslint-disable-next-line prefer-const
  let arr: IKeyValue[] = [];
  listCampanha.map(campanha => (
    arr.push({ key: campanha.CodigoCampanha, value: `${campanha.CodigoCampanha} - ${campanha.NomeCampanha}` })
  ));
  return arr;
};

export const getValueFromKeyValue = (list: IKeyValue[], key: string): string => {
  let valor = '';
  list.map(reg => {
    if (reg.key.trim().toUpperCase() === key.trim().toUpperCase()){
      valor = reg.value;
      return;
    }
  } );
  return valor;
};

export const calculateRemainingTime = (expirationTime: number) => {
  const currentTime = new Date().getTime();

  const remainingDuration = expirationTime - currentTime;

  return remainingDuration;
};